export const englishText = {
	'access.requestSentFor': 'has sent an access request for',
	'activity.noTasks': 'You have no tasks',
	'activity.sendWithDropbox': 'has sent you files with External Uploader',
	'activity.yourTasks': 'Your tasks',
	'admin.accountManagement': 'Account Management',
	'admin.aiAgents': 'AI Agents',
	'admin.agentActivity': 'Agent activity',
	'admin.aiEnrichment': 'Enrichment',
	'admin.aiTransformation': 'Transformation',
	'admin.aiVectorPath': 'Clipping paths',
	'admin.aiAgents.manage': 'Manage AI Agents',
	'admin.aiControlCenter': 'AI Control Center',
	'admin.bynderResources': 'Bynder Resources',
	'admin.knowledgeBase': 'Knowledge base',
	'admin.submitRequest': 'Submit a request',
	'admin.community': 'Community',
	'admin.advancedSettings': 'Advanced settings',
	'admin.analytics': 'Analytics',
	'admin.compliance': 'Brand Compliance',
	'admin.governance': 'Governance',
	'admin.brandTemplates': 'Brand templates',
	'admin.bynderSuperadmin': 'Bynder superadmin',
	'admin.cockpit': 'Cockpit',
	'admin.editCurrentAccount': 'Edit current account',
	'admin.groupManagement': 'Group Management',
	'admin.homepage': 'Homepage',
	'admin.homepageV2': 'Homepage',
	'admin.insights': 'Insights',
	'admin.lookAndFeel': 'Look & feel',
	'admin.metapropertiesmanagement': 'Metaproperties management',
	'admin.permissionManagement': 'Permission Management',
	'admin.portalSettings': 'Portal settings',
	'admin.reporting': 'Reporting',
	'admin.smartfilterManagement': 'Smartfilter Management',
	'admin.taxonomy': 'Taxonomy',
	'admin.trash': 'Trash',
	'admin.userManagement': 'User Management',
	'admin.usersRights': 'Users & rights',
	'admin.workflow': 'Workflow',
	'adminExtra.newsManagement': 'News Management',
	'brands.makeNew': 'Create new brand',
	'brandstore.goTo': 'Go to brandstore',
	'brandstore.MyCart': 'My cart',
	'brandstore.orderHistory': 'Order history',
	'cart.goToMy': 'Go to my cart',
	'cart.total': 'Cart total',
	'cart.youHaveNoItems': 'You have no products in your cart',
	'collections.allFor': 'All collections for',
	'confirm.RemoveGroup': 'Remove group',
	convertGuidelines: 'Convert Guidelines to PDF',
	'conversationalAi.toggleSidebar': 'Toggle Conversational A.I. sidebar',
	'download.progress': 'download(s) being prepared',
	'download.requestSent': 'has sent a download request.',
	'downloadtask.progress': 'edits/downloads in progress',
	'duplicate.find': 'Find duplicates',
	generalAnotherSearch: 'Why not try another search?',
	generalAudit: 'Audit',
	generalBack: 'Back',
	generalBrands: 'Brands',
	generalCancel: 'Cancel',
	generalCategories: 'Categories',
	generalChangeHistory: 'Change history',
	generalClear: 'Clear',
	GeneralCopyright: 'Copyright',
	generalDownload: 'Download',
	generalErrorSavingChanges: 'Error saving changes',
	generalLanguage: 'Language',
	generalLogin: 'Login',
	generalLogout: 'Logout',
	generalMore: 'More',
	generalNoResultsFor: 'No results for',
	generalQuickLinks: 'Quick links',
	generalResultsFor: 'Results for',
	generalSearch: 'Search',
	generalSettings: 'Settings',
	generalTags: 'Tags',
	generalTaskDownloadReady: 'is ready',
	generalUploadMedia: 'Upload media',
	generalWatch: 'View',
	includeVat: 'Inc. VAT',
	'news.addNews': 'Add news',
	'menuitem.bynderExpress': 'Bynder Express',
	'menuitem.customLinks': 'Custom links',
	'badge.label.new': 'New',
	noresults: 'There are currently no results',
	'quarantine.quarantine': 'Quarantine',
	'request.requestAccess': 'Register a new account',
	save: 'Save',
	'spotlight.dropdown.assets': 'Assets',
	'spotlight.dropdown.assets.count':
		'{count, plural, one {{count} Asset} other {{count} Assets}}',
	'spotlight.dropdown.assets.heading': 'Top Assets',
	'spotlight.dropdown.assets.noMatch': 'No Assets match',
	'spotlight.dropdown.collections': 'Collections',
	'spotlight.dropdown.collections.count':
		'{count, plural, one {{count} Collection} other {{count} Collections}}',
	'spotlight.dropdown.collections.heading': 'Top Collections',
	'spotlight.dropdown.collections.noMatch': 'No Collections match',
	'spotlight.dropdown.collections.notSearchableWithSearchOptions':
		"Collections can't be searched by title or description",
	'spotlight.dropdown.guidelines': 'Guidelines and landing pages',
	'spotlight.dropdown.guidelines.only': 'Guidelines',
	'spotlight.dropdown.guidelines.only.count':
		'{count, plural, one {{count} Guideline} other {{count} Guidelines}}',
	'spotlight.dropdown.guidelines.noMatch': 'No Guidelines match',
	'spotlight.dropdown.guidelines.notSearchableWithSearchOptions':
		"Guidelines can't be searched by title or description",
	'spotlight.searchOptionsDropdown.trigger.label.all': 'Search in: All',
	'spotlight.searchOptionsDropdown.title': 'Search in',
	'spotlight.dropdown.noResults': 'No results',
	'spotlight.dropdown.noResults.subtitle': 'Try starting a new search',
	'spotlight.dropdown.tags': 'Tags',
	'spotlight.dropdown.metaproperties': 'Metaproperties',
	'spotlight.dropdown.metaproperty': 'Metaproperty',
	'spotlight.dropdown.help': 'Help',
	'spotlight.dropdown.viewAll': 'View all',
	'spotlight.dropdown.collectionFiles': 'files',
	'spotlight.searchSomething': 'Search assets...',
	'spotlight.searchSomethingNLS': "Describe what you're looking for...",
	'spotlight.redesign.searchPlaceholder': 'Type / to search assets...',
	'spotlight.redesign.searchPlaceholderNLS': "Type / to describe what you're looking for...",
	'spotlight.redesign.clearInput': 'Clear input',
	'spotlight.button.text': 'Click here or type / to search',
	'spotlight.showMetaPropertyResults': 'All {1} results for {2}',
	'spotlight.text': 'Text',
	'spotlight.textInImage': 'Text in image',
	'spotlight.nlsBannerTitle': 'Natural language search is On',
	'spotlight.nlsBannerSubtitle': 'Search images by describing the scene, objects, or situations.',
	'spotlight.nlsBannerSubtitleHybrid': 'Combines keyword matches with visually similar assets.',
	'spotlight.nlsBannerTitleOff': 'Natural language search is Off',
	'spotlight.nlsBannerSubtitleOff': 'Search all assets by title, tags, name, and metadata.',
	'spotlight.searchByImage': 'Search by image',
	'spotlight.searchByImage.upload.title': 'Upload an image to search.',
	'spotlight.searchByImage.upload.subtitle': 'We support JPG, JPEG, PNG, WEBP, AVIF images.',
	'spotlight.searchByImage.upload.button': 'Upload',
	'spotlight.searchByImage.operator': 'OR',
	'spotlight.searchByImage.link.placeholder': 'Paste image link',
	'spotlight.searchByImage.link.instructions': 'How to copy and paste links',
	'spotlight.searchByImage.upload.unsupportedFileType':
		'Unsupported file type. Please upload a different image file.',
	'spotlight.searchByImage.upload.error':
		'Something went wrong uploading your image. Please try again.',
	'spotlight.searchModeDropdown.trigger.keyword': 'Keyword',
	'spotlight.searchModeDropdown.trigger.aiPowered': 'AI-powered',
	'spotlight.searchModeDropdown.option.keyword.title': 'Keyword Search',
	'spotlight.searchModeDropdown.option.keyword.subtitle':
		'Search all assets by title, tags, name, and metadata.',
	'spotlight.searchModeDropdown.option.aiPowered.title': 'AI-powered Search',
	'spotlight.searchModeDropdown.option.aiPowered.subtitle':
		'Search images by describing the scene, objects, or situations.',
	'spotlight.searchModeDropdown.option.aiPowered.subtitleHybrid':
		'Combines keyword matches with visually similar assets.',
	'spotlight.explainabilityBadge.visualMatch': 'Visual',
	'spotlight.explainabilityBadge.description': 'Description',
	'spotlight.explainabilityBadge.metadata': 'Metadata',
	'spotlight.explainabilityBadge.textInDocument': 'Document',
	'spotlight.explainabilityBadge.lexicalMatch': 'Info',
	'spotlight.transcript': 'Transcript',
	'spotlightHelp.operators.and.content':
		'Use AND between your search terms to find results that match all your terms.',
	'spotlightHelp.operators.and.example': 'E.g. boston {and} hotel',
	'spotlightHelp.operators.and.title': 'AND operator',
	'spotlightHelp.operators.combinations.content':
		'All the search operators mentioned above can also be used together.',
	'spotlightHelp.operators.combinations.example': 'E.g. bicycle {andnot} city',
	'spotlightHelp.operators.combinations.title': 'Combinations',
	'spotlightHelp.operators.nav': 'Search Operators',
	'spotlightHelp.operators.not.content':
		'Use NOT before a search term to exclude results that match that term.',
	'spotlightHelp.operators.not.example': 'E.g. {not} forest',
	'spotlightHelp.operators.not.title': 'NOT operator',
	'spotlightHelp.operators.or.content':
		'Use OR between your search terms to find results that match any of your terms.',
	'spotlightHelp.operators.or.example': 'E.g. ocean {or} mountains',
	'spotlightHelp.operators.or.title': 'OR operator',
	'spotlightHelp.operators.quotes.content':
		'Wrap your search in “” to find results that are an exact match.',
	'spotlightHelp.operators.quotes.example': 'E.g. “ocean view”',
	'spotlightHelp.operators.quotes.title': 'Double quotes',
	'spotlightHelp.operators.title': 'Search Operators',
	'spotlightHelp.recentSearches': 'Recent',
	'spotlightHelp.recentSearchesRedesign': 'Recent Searches',
	'spotlightHelp.shortcuts.close.key': 'ESC',
	'spotlightHelp.shortcuts.close.title': 'Close search',
	'spotlightHelp.shortcuts.down.key': 'Arrow down',
	'spotlightHelp.shortcuts.down.title': 'Navigate to next result',
	'spotlightHelp.shortcuts.nav': 'Keyboard Shortcuts',
	'spotlightHelp.shortcuts.title': 'Keyboard shortcuts',
	'spotlightHelp.shortcuts.up.key': 'Arrow up',
	'spotlightHelp.shortcuts.up.title': 'Navigate to previous result',
	'spotlightHelp.shortcuts.view.key': 'ENTER',
	'spotlightHelp.shortcuts.view.title': 'View results',
	'spotlightHelp.title': 'Search Help',
	'spotlight.searchOptions.search-in': 'Search in',
	'spotlight.searchOptions.chips.title': 'Title',
	'spotlight.searchOptions.chips.description': 'Description',
	'spotlight.searchOptions.title': 'Title contains: {1}',
	'spotlight.searchOptions.description': 'Description contains: {1}',
	'spotlight.searchOptions.combined': 'Title and description contain: {1}',
	'spotlight.searchOptions.extension': 'Extension',
	'spotlight.searchOptions.extension.allFiles': 'All files',
	'spotlight.searchOptions.extension.search': 'Search',
	'spotlight.searchOptions.extension.label': 'All file types',
	'spotlight.searchOptions.extension.clearAll': 'Clear all',
	'spotlight.searchOptions.extension.noResults': 'No file type found',
	'spotlight.searchOptions.extension.fileType.image': 'Image',
	'spotlight.searchOptions.extension.fileType.video': 'Video',
	'spotlight.searchOptions.extension.fileType.audio': 'Audio',
	'spotlight.searchOptions.extension.fileType.document': 'Document',
	'spotlight.searchOptions.extension.fileType.archive': 'Archive',
	'spotlight.searchOptions.extension.fileType.other': 'Other',
	'spotlight.searchOptions.extension.fileType.3d': '3D',
	'spotlight.searchOptions.extension.fileType.font': 'Font',
	'spotlight.searchOptions.extension.fileType.design': 'Design',
	'spotlight.dropdown.footer.close': 'Close',
	'spotlight.dropdown.footer.down': 'Down',
	'spotlight.dropdown.footer.navigate': 'Navigate',
	'spotlight.dropdown.footer.search': 'Search',
	'spotlight.dropdown.footer.select': 'Select',
	'spotlight.dropdown.footer.up': 'Up',
	'tags.allTagsFor': 'All tags for',
	'task.progress': 'edit(s) in progress',
	'transfer.history': 'Transfer history',
	'upload.bareUploader': 'Mass Uploader',
	'upload.versionUpdater': 'Mass Version Updater',
	'user-outofoffice.BackupUnavailable':
		'This person is unavailable in the selected time range. Please adjust your dates or select someone else.',
	'user-outofoffice.BackupUser': 'Set as backup user',
	'user-outofoffice.Description.KeepReceivingNotifications':
		"Stay in the loop while you're unavailable",
	'user-outofoffice.EndDate': 'End date',
	'user-outofoffice.IsOutOfOfficeUntil': 'Out of office until {1}',
	'user-outofoffice.KeepReceivingNotifications': 'Keep receiving notifications',
	'user-outofoffice.MainAlreadyBackup':
		'You are set as backup for another user in the selected time range. Please adjust your dates.',
	'user-outofoffice.SearchForAUser': 'Search for a user',
	'user-outofoffice.SetOutOfOfficeClear': 'Clear out of office',
	'user-outofoffice.SetOutOfOfficeClearError':
		'We weren’t able to clear your out of office, please try again later.',
	'user-outofoffice.SetOutOfOfficeClearSuccess':
		'Your out of office has been cleared successfully',
	'user-outofoffice.SetOutOfOfficeSuccess': 'Your out of office has been set successfully',
	'user-outofoffice.SetYourselfAsOutOfOffice': 'Set yourself as out of office',
	'user-outofoffice.StartDate': 'Start date',
	'user-outofoffice.UserHasOverlapingOOO':
		'You are already set as out of office in this time range',
	'user.editProfile': 'Edit profile',
	'user.requests': 'User Access Requests',
	'user.workspace': 'Workspace',
	'waitingroom.waitingroom': 'Waiting room',
	'workflow.AddAsset': 'Add asset',
	'workflow.AddGroup': 'Add group',
	'workflow.AddPreset': 'Add preset',
	'workflow.Campaign': '{Campaign}',
	'workflow.CampaignManagement': 'Campaign Management',
	'workflow.Cancel': 'Cancel',
	'workflow.Close': 'Close',
	'workflow.CreateNew': 'Create new',
	'workflow.DeleteConfirmation': 'Are you sure you want to remove {1}?',
	'workflow.EditGroup': 'Edit group',
	'workflow.FTEManagement': 'FTE Management',
	'workflow.GroupManagement': 'Group Management',
	'workflow.Job': '{Job}',
	'workflow.ManageGroups': 'Manage groups',
	'workflow.MetapropertyManagement': 'Metaproperty Management',
	'workflow.Name': 'Name',
	'workflow.No': 'No',
	'workflow.NoGroup': 'No groups found',
	'workflow.PresetManagement': 'Preset Management',
	'workflow.PresetsCampaign': 'Campaign Presets',
	'workflow.PresetsJob': 'Job Presets',
	'workflow.CampaignPresets': '{Campaign} presets',
	'workflow.JobPresets': '{Job} presets',
	'workflow.Remove': 'Remove',
	'workflow.RoleManagement': 'Role Management',
	'workflow.Save': 'Save',
	'workflow.StageAdd': 'Add stage',
	'workflow.StartAddGroup': 'Start adding your first group',
	'workflow.TaskAdd': 'Add task',
	'workflow.TemplateManagement': 'Template Management',
	'workflow.Users': 'Users',
	'workflow.VariableManagement': 'Variable Management',
	'workflow.YesRemove': 'Yes, remove',
	'generateWithPrompt.title': 'Create AI image',
	'generateWithPrompt.notification.error.title': 'Something went wrong',
	'generateWithPrompt.notification.unsupported-document.title':
		'Document files (DOC, DOCX) are not supported as reference assets',
	'generateWithPrompt.save-notification.error.title': 'Failed to save asset',
	'generateWithPrompt.save-notification.error.description':
		'There was an error saving your asset. Please try again.',
	'generateWithPrompt.save-notification.error.code.technical_error.title': 'Something went wrong',
	'generateWithPrompt.save-notification.error.code.technical_error.description':
		'Please try again later.',
	'generateWithPrompt.save-notification.error.code.file_type_not_supported.title':
		'File not supported',
	'generateWithPrompt.save-notification.error.code.file_type_not_supported.description':
		'The provided file type is not supported.',
	'generateWithPrompt.save-notification.error.code.output_max_tokens_exceeded.title':
		'Request too large',
	'generateWithPrompt.save-notification.error.code.output_max_tokens_exceeded.description':
		'The request was too large to process. Please simplify your prompt and try again.',
	'generateWithPrompt.save-notification.error.code.file_size_exceeded.title': 'Image too large',
	'generateWithPrompt.save-notification.error.code.file_size_exceeded.description':
		'The provided file exceeds the maximum allowed size.',
	'generateWithPrompt.save-notification.error.code.guardrail_input_violation.title':
		'Content policy violation',
	'generateWithPrompt.save-notification.error.code.guardrail_input_violation.description':
		'Your request could not be processed because the input violates content policies.',
	'generateWithPrompt.save-notification.error.code.guardrail_output_violation.title':
		'Content policy violation',
	'generateWithPrompt.save-notification.error.code.guardrail_output_violation.description':
		'The image could not be generated because the result violated content policies. Please adjust your prompt and try again.',
	'generateWithPrompt.save-notification.error.code.thumbnail_not_ready.title':
		'Thumbnail not ready',
	'generateWithPrompt.save-notification.error.code.thumbnail_not_ready.description':
		'The thumbnail is not ready yet.',
	'generateWithPrompt.save-notification.title.dam': 'Asset saved',
	'generateWithPrompt.save-notification.title.waiting-room': 'Asset sent to waiting room',
	'generateWithPrompt.save-notification.description.waiting-room':
		'You will be notified once it has been approved.',
	'generateWithPrompt.save-notification.link.dam': 'Go to asset',
	'generateWithPrompt.save-notification.link.waiting-room': 'Go to waiting room',
	'generateWithPrompt.save-notification.link.close': 'Close',
};
